import React from 'react'
import PropTypes from 'prop-types'
import Heading from '../../atoms/Heading'
import Text from '../../atoms/Text'
import ProjectCard from '../../molecules/ProjectCard'
import styles from './ProjectsGrid.module.css'

/**
 * Composant Organisme : ProjectsGrid
 *
 * Grille de projets/événements
 *
 * @component
 */
const ProjectsGrid = ({ title, subtitle, projects }) => {
  return (
    <section className={styles.projects} id="evenements">
      <div className={styles.sectionHeader}>
        <Heading level={2}>{title}</Heading>
        <Text size="large">{subtitle}</Text>
      </div>
      <div className={styles.projectsGrid}>
        {projects.map((project, index) => (
          <ProjectCard
            key={index}
            {...project}
            style={{ animationDelay: `${index * 0.15}s` }}
          />
        ))}
      </div>
    </section>
  )
}

ProjectsGrid.propTypes = {
  title: PropTypes.string.isRequired,
  subtitle: PropTypes.string.isRequired,
  projects: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string.isRequired,
      category: PropTypes.string.isRequired,
      year: PropTypes.string.isRequired,
      color: PropTypes.string.isRequired,
      link: PropTypes.string,
    })
  ).isRequired,
}

export default ProjectsGrid
